import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoPedido } from '../models/tipo-pedido.model';

@Injectable({
  providedIn: 'root',
})
export class TipoPedidoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all tipo pedidos
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: TipoPedido[] }>(
        `${this.path}/getAllTipoPedido`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Get tipo pedido by ID
  public show(id: string): Observable<TipoPedido> {
    return this.apiService
      .get<{ object: TipoPedido }>(`${this.path}/getTipoPedidoById/${id}`)
      .pipe(map((response) => response.object as TipoPedido));
  }

  // Create new tipo pedido
  public store(form: TipoPedido): Observable<TipoPedido> {
    const tipoPedido = form as TipoPedido;
    return this.apiService
      .post<{ object: TipoPedido }>(`${this.path}/AddTipoPedido`, tipoPedido)
      .pipe(map((response) => response.object as TipoPedido));
  }

  // Update existing tipo pedido
  public update(form: FormGroup, id: string): Observable<TipoPedido> {
    const tipoPedido = form.value as TipoPedido;
    return this.apiService
      .put<{ object: TipoPedido }>(
        `${this.path}/UpdateTipoPedido/${id}`,
        tipoPedido
      )
      .pipe(map((response) => response.object as TipoPedido));
  }

  // Delete existing tipo pedido
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoPedidoById/${id}`);
  }
}
